<template>
  <div class="animated fadeIn">
	<b-card>
      <b-row>
        <b-col sm="5">
          <h4 id="traffic" class="card-title mb-0">Therapist Loading</h4>
          <div class="small text-muted">...</div>
        </b-col>
        <b-col sm="7" class="d-none d-md-block">
          <b-button-toolbar class="small text-muted float-right" aria-label="Toolbar with buttons group">
						<b-form-group label="Period" class="small text-muted" >
							<b-form-radio-group label="Period" id="radiosBtn" buttons size="sm" button-variant="outline-secondary" v-model="selected" name="radiosBtn">
								<b-form-radio class="mx-0" value="day">Day</b-form-radio>
								<b-form-radio class="mx-0" value="week">Week</b-form-radio>
								<b-form-radio class="mx-0" value="month">Month</b-form-radio>
								<b-form-radio class="mx-0" value="all">All</b-form-radio>
							</b-form-radio-group>
						</b-form-group>
						&nbsp;&nbsp;
						<b-button size="sm" type="button" variant="outline-primary" class="float-right" @click.preventDefault="getDataAsCSV"><i class="icon-cloud-download"></i>&nbsp;&nbsp;CSV</b-button>

          </b-button-toolbar>
					<b-button-toolbar class="float-right" aria-label="Toolbar with buttons group">
						<b-col>
							<b-form-group label="Since" class="small text-muted" >
								<b-form-input size="sm" id="since" type="date" v-model="since"></b-form-input>
							</b-form-group>
						</b-col>
						<b-col>
							<b-form-group label="Until" class="small text-muted" >
								<b-form-input size="sm" id="until" type="date" v-model="until"></b-form-input>
							</b-form-group>
						</b-col>

					</b-button-toolbar>
        </b-col>
      </b-row>
	  <b-row class="text-center">
			<b-input-group size="sm" prepend="Therapist" class="mt-3">
		  	<b-form-select v-model="selected_therapist" :options="therapist_opts"></b-form-select>
				<b-input-group-append>
					<b-button v-b-toggle.therapistprofile variant="outline-success">View Profile</b-button>
				</b-input-group-append>
			</b-input-group>

		</b-row>
		<b-row class="text-center">
			<b-col>
				<b-collapse id="therapistprofile" class="mt-3">
						<b-card>
							<b-card-text><h3>{{this.therapist_obj.last_name}}, {{this.therapist_obj.first_name}}</h3></b-card-text>
							<b-form id="therapistUpdateform">
								<b-row>
									<b-col>
										<b-input-group size="sm" prepend="Monthly Goal" append="#">
											<b-form-input v-model="therapist_obj.target_visits_per_month"></b-form-input>
										</b-input-group>
										<b-input-group size="sm" prepend="Weekly Goal" append="#">
											<b-form-input v-model="therapist_obj.this_weeks_goal"></b-form-input>
										</b-input-group>
									</b-col>
									<b-col>
										<b-form-radio-group label="Status" id="status" name="status" buttons size="sm" button-variant="outline-secondary" v-model="therapist_obj.ft_pt">
											<b-form-radio class="mx-0" value="Full-Time">Full-Time</b-form-radio>
											<b-form-radio class="mx-0" value="Part-Time">Part-Time</b-form-radio>
										</b-form-radio-group>
									</b-col>
									<b-col>
										<b-form-radio-group label="Type" id="type" name="type" buttons size="sm" button-variant="outline-secondary" v-model="therapist_obj.pt_pta">
											<b-form-radio class="mx-0" value="PT">Physical Therapist</b-form-radio>
											<b-form-radio class="mx-0" value="PTA">Physical Therapist Assistant</b-form-radio>
										</b-form-radio-group>
									</b-col>

								</b-row>
								<b-col md-6>
										<b-button-group size="sm">
											<b-button variant="success" @click="updateTherapist" data-target="therapistUpdateform">Save</b-button>
											<b-button variant="danger" v-b-toggle.therapistprofile>Cancel</b-button>
										</b-button-group>
								</b-col>
							</b-form>
						</b-card>

				</b-collapse>
			</b-col>
		</b-row>
	  <b-row>
		  <b-table show-empty sticky-header small striped hover responsive :items="raw_data" :fields="fields" tbody-tr-class="text-nowrap" head-variant="light">
			<!--<b-table striped hover :items="raw_data" :fields="table_fields">-->
				<template slot="[therapistname]" slot-scope="data">
					{{ data.item.last_name }}, {{ data.item.firs_name }}&nbsp; <b-badge variant="dark" pill>{{data.item.pt_pta}}</b-badge>&nbsp;
						<b-badge v-if="data.item.ft_pt=='Full-Time'" variant="success">{{data.item.ft_pt}}</b-badge>
						<b-badge v-else variant="warning">{{data.item.ft_pt}}</b-badge>
				</template>

		  </b-table>
	  </b-row>
      <div slot="footer">
        ...
      </div>
    </b-card>
  </div>
</template>

<script>
var qs = require('qs');
import moment from 'moment-timezone'
export default {
  name: 'TherapistLoading',
  mounted() {
	    this.getTherapists()
		this.getData()
  },
  data: function () {
    return {
		selected: "Month",
		active_only: false,
		since: moment().subtract(1, "months").startOf("month").format("YYYY-MM-DD"),
		until: moment().add(1, "month").endOf("month").format("YYYY-MM-DD"),
		raw_data: [],
		selected_therapist: '',
		therapist: '',
		therapist_obj: [],
		therapist_list: [],
		therapist_opts: [],
		therapist_opts_default: [{value: '', text: "Please select a Therapist", }],
		fields: [],
    }
  },
  watch: {
	  selected: function(v, old) {
		  if (v == 'month') {
				this.since = moment().startOf("month").format("YYYY-MM-DD")
		  	this.until = moment().add(1, "month").endOf("month").format("YYYY-MM-DD")
		  } else {
				this.since = moment().startOf("month").format("YYYY-MM-DD")
		  	this.until = moment().endOf("month").format("YYYY-MM-DD")
		  }

		  // Day = Last Week, Current, Next
		  // Week = Last Week, Currnet, Next
		  // Month = Last Month, Current, Next
		  this.getData()
	  },
	  since: function(v, old) {
		  this.getData()
	  },
	  until: function(v, old) {
		  this.getData()
	  },
	  therapist_list: function (v, old) {
		  let $this = this
		  this.therapist_opts = this.therapist_opts_default
		  v.forEach( function(v, i) {
				$this.therapist_opts.push({value: i, text: `${v.last_name}, ${v.first_name}`})
		  })
	  },
	  selected_therapist: function(v, old) {
			this.therapist = v in this.therapist_list && this.therapist_list[v].hasOwnProperty('id') ? this.therapist_list[v].id :  ''
			this.therapist_obj = v in this.therapist_list ? this.therapist_list[v] : []
		  this.getData()
	  }
  },
  methods: {
		updateTherapist(e) {
			e.preventDefault()
			let initiator = e.srcElement
			let $this = this
			initiator.disabled="true"
			initiator.innerHTML = "Saving..."

			var target = e.srcElement.dataset.target
			var form = document.getElementById(target)
			var therapist_id = this.therapist_obj.id
			this.$newpetehealthapi.post("/therapists/"+therapist_id, {
				ft_pt: this.therapist_obj.ft_pt,
				weekly_goal: this.therapist_obj.this_weeks_goal,
				monthly_goal: this.therapist_obj.target_visits_per_month,
				pt_pta: this.therapist_obj.pt_pta,
			}).then( function (r) {
				//console.log(r)
				initiator.innerHTML = "Save"
				initiator.disabled=false
				$this.$root.$emit('bv::toggle::collapse', 'therapistprofile')
				return true;
			})
		},
		getTherapists() {
			let $this = this
			var base_url = "/therapists"
			var opts = []
			if (this.active_only !== '') {
				opts.active = true
			}

			this.$newpetehealthapi.get(base_url, {
				params: opts,
				paramsSerializer: params => {
					return qs.stringify(params)
				}
			}).then( function (r) {
				//console.log(r.data)
				$this.therapist_list = r.data
				return true
			})
		},
		getData() {
			let $this = this
			var base_url = "/tload"
			var opts = [];
			if (this.selected !== '') {
				opts.period = this.selected
			}

			if (this.therapist !== '') {
				opts.therapist_id = this.therapist
			}

			if(this.since !== '') {
				opts.since = moment(this.since).format("YYYY-MM-DD")
			}

			if(this.until !== '') {
				opts.until = moment(this.until).format("YYYY-MM-DD")
			}

			//console.log(opts)
			this.$newpetehealthapi.get(base_url, {
				params: opts,
				paramsSerializer: params => {
					return qs.stringify(params)
				}
			}).then( function (r) {
				//console.log(r.data)
				$this.fields = []
				$this.raw_data = []
				if (r.data.length > 0) {

					Object.keys(r.data[0]).forEach( function (v, i) {
						if ($this.nonext && v == 'id' && $this.group_by !== '') {
							return
						}
						$this.fields.push({key: v, sortable: v !=='id'})
					})
					$this.raw_data = r.data
			  }
				return true
			})
		},

		getDataAsCSV(e) {
			var params = []
			params.csv = true
			if (this.selected !== '') {
				params.period = this.selected
			}

			if (this.therapist !== '') {
				params.therapist_id = this.therapist
			}

			if(this.since !== '') {
				params.since = moment(this.since).format("YYYY-MM-DD")
			}

			if(this.until !== '') {
				params.until = moment(this.until).format("YYYY-MM-DD")
			}

			var endpoint = "/tload"
			var filename = "PH_TLoad_"+moment(new Date()).format("YYYYMMDD")+".csv"

			this.$newpetehealthapi.get(endpoint, {
				params: params,
				paramsSerializer: params => {
					return qs.stringify(params)
				}
			}).then( (r) => {
				//console.log(this.therapist_summary)
				const url = window.URL.createObjectURL(new Blob([r.data]))
				const link = document.createElement('a')
				link.href = url
				link.setAttribute('download', filename)
				document.body.appendChild(link)
				link.click()
				link.parentNode.removeChild(link)
			})
		},
  },

}
</script>
